<template>
  <div>
    <!-- <SearchSelect v-bind="$attrs" :api="apiGroupName" prop="citys" :get-value="getValue" :get-label="getLabel" v-on="$listeners" /> -->
    <el-select
      v-model="data['citys']"
      :multiple="true"
      :collapse-tags="true"
      :clearable="true"
      style="width: 100%;"
      :placeholder="$t('performanceAppraisal.evaluationSystem.chooseMore')"
    >
      <el-option
        v-for="item in cityOps"
        :key="item"
        :label="item"
        :value="item"
      />
    </el-select>
  </div>
</template>

<script>
// import SearchSelect from '@/components/select/search-select/search-select.vue'
import http from '@/plugin/axios'

export default {
  components: {
    // SearchSelect
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      cityOps: []
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      this.cityOps = await this.apiGroupName()
    },
    apiGroupName() {
      return http({
        url: '/examineAssessSystem/getSupplierCity',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        loading: false
      })
    },
    getValue: (row) => row,
    getLabel: (row) => `${row}`
  }
}
</script>

<style lang="scss" scoped>

</style>
